import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import { useRouter } from 'next/router'
import styles from "./styles.module.scss";
import Link from "next/link";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { motion, useTransform, useScroll } from "framer-motion";
import BlogAuthor from "../BlogAuthor";
import { getJobApplyUrl } from "../../functions/getJobApplyUrl";

export default function SubBanner({
  global,
  pathPrefix,
  customClass = "",
  buttonLink,
  buttonTitle,
  post,
  author,
  heading,
  all_consultants,
  consultantPage = false,
  bannerImage,
  bannerImage2,
  customBannerColor,
  branchId,
  jobType,
  bannerImageAlt,
  bannerImageAlt2,
  dualBannerImage = false,
  MainButtonTitle,
  MainButtonLink,
  jobApplyButtonText,
  jobPage = false,
  logoBanner = false,
  bottomBannerCTA = false,
  buttomBannerCTALINK,
  buttomBannerCTATitle,
}) {
  const router = useRouter();

  const handleButtonClick = (e) => {
    if (jobPage) {
      router.back();
      e.preventDefault();
    }
  };

  // Author V2 comes through as a prop, older articles only carry the free-text author
  const blogAuthor = author || post?.author;

  const titleVariants = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };

  const jobApplyUrl = jobPage ? getJobApplyUrl({ job: post, branchId, jobType }) : "";

  return (
    <>
      <section className={`${styles.root} ${customClass}`}>
        <Container>
          <div
            className={`content-wrapper rounded-3 shadow position-relative ${
              dualBannerImage
                ? "dualBannerImage py-lg-5 ps-lg-5  pt-4 ps-4 pb-4"
                : "overflow-hidden p-lg-5 p-4"
            }`}
            style={{backgroundColor: customBannerColor}}
          >
            {bannerImage ? (
              <SourceFlowImage
                src={bannerImage}
                size={`${logoBanner ? "800x" : "800x800"}`}
                alt={bannerImageAlt}
                className={`card-img rounded-0 banner-1 position-absolute ${
                  dualBannerImage
                    ? "rounded-3 shadow slideUp"
                    : "default-banner"
                } ${logoBanner ? "logo-banner p-4" : ""}`}
                width="100%"
                height="100%"
              />
            ) : (
              ""
            )}
            {bannerImage2 ? (
              <SourceFlowImage
                src={bannerImage2}
                size={`${logoBanner ? "800x" : "800x800"}`}
                alt={bannerImageAlt2}
                className={`card-img rounded-0 banner-2 position-absolute ${
                  dualBannerImage
                    ? "rounded-3 shadow slideUp"
                    : "default-banner"
                }`}
                width="100%"
                height="100%"
              />
            ) : (
              ""
            )}
            {buttonLink ? (
              <Link href={buttonLink}>
                <a className="text-decoration-none primaryBtn-outline-white left-arrow rounded-5" onClick={handleButtonClick}>
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.buttonTitle`}
                  >
                    {buttonTitle}
                  </SourceFlowText>
                </a>
              </Link>
            ) : (
              <>
                <span className="d-inline-block primaryBtn-outline-white no-arrow rounded-5 no-cursor">
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.buttonTitle`}
                  >
                    {buttonTitle}
                  </SourceFlowText>
                </span>
              </>
            )}
            {jobPage ? (
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                <motion.h1
                  initial="hidden"
                  animate="visible"
                  variants={titleVariants}
                  className="post-title mt-4 position-relative"
                >
                  {post?.title ? (
                    post.title
                  ) : (
                    <SourceFlowText
                      global={global}
                      path={`${pathPrefix}.heading`}
                    >
                      {heading}
                    </SourceFlowText>
                  )}
                </motion.h1>
                <div className="mt-4 mt-lg-0">
                  <Link href={jobApplyUrl}>
                    <a className="primaryBtn-outline-white applybtn m-0 shadow">
                      <strong>
                        <SourceFlowText
                          global={global}
                          path={`${pathPrefix}.jobApplyButtonText`}
                        >
                          {jobApplyButtonText}
                        </SourceFlowText>
                      </strong>
                    </a>
                  </Link>
                </div>
              </div>
            ) : (
              <motion.h1
                initial="hidden"
                animate="visible"
                variants={titleVariants}
                className="post-title mt-4 mt-md-5 position-relative"
              >
                {consultantPage ? (
                  <>
                    {post?.name ? (
                      post.name
                    ) : (
                      <SourceFlowText
                        global={global}
                        path={`${pathPrefix}.heading`}
                      >
                        {heading}
                      </SourceFlowText>
                    )}
                  </>
                ) : (
                  <>
                    {post?.title ? (
                      post.title
                    ) : (
                      <SourceFlowText
                        global={global}
                        path={`${pathPrefix}.heading`}
                      >
                        {heading}
                      </SourceFlowText>
                    )}
                  </>
                )}
              </motion.h1>
            )}
            {MainButtonLink ? (
              <div className="mt-4 position-relative z-index-1">
                <Link href={MainButtonLink}>
                  <a className="primaryBtn-outline-white text-decoration-none text-white">
                    <SourceFlowText
                      global={global}
                      path={`${pathPrefix}.MainButtonTitle`}
                    >
                      {MainButtonTitle}
                    </SourceFlowText>
                  </a>
                </Link>
              </div>
            ) : (
              ""
            )}
            {post ? (
              <>
                {post?.position ? (
                  <p className="subtitle position mt-4 d-flex align-items-center justify-content-md-start position-relative">
                    <small>{post?.position}</small>
                  </p>
                ) : (
                  ""
                )}
                {blogAuthor ? (
                  <BlogAuthor
                    author={blogAuthor}
                    consultant={all_consultants?.name ? all_consultants : null}
                    customClass={`on-dark mt-4 mt-md-5`}
                  />
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </Container>
      </section>
    </>
  );
}
